import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/our-chat/platform-back.webp";

function Platformfeature() {
  return (
    <section
      className="platform_feature platform_chat p-100 text_chat"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="text-center resp_order offset-xl-2 offset-lg-2"
          >
            <div className="platform_chat_img">
              <StaticImage
                src="../../../images/case-studies/our-chat/platform-mob.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={497}
                height={750}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              Platform <span>Features</span>
            </h2>
            <p>
              With OurChat, users can enjoy a range of exciting features that
              make it easier than ever to connect with professionals and get the
              help they need. The app offers a ‘social sign-in’ feature, making
              it easy for users to sign up and log in using their existing
              social media accounts. It also features ‘Yelp integration’,
              providing users access to millions of reviews and ratings from
              real customers, making it easier for you to find the right
              professional for your needs. OurChat also offers a ‘swipe left and
              right feature’, allowing you to easily accept or reject interested
              users, and a ‘chat function’ which allows you to communicate with
              interested users.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformfeature;
